import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { Heading } from "components/Heading";
import Inbox from "../tabs/Inbox";
import typography from "../typography";

export default function InboxScreen() {
  return (
    <div className="page-content">
      <Helmet>
        <title>{typography.TAB_INBOX} · MCAP</title>
      </Helmet>
      <Container fluid className="mcap-hub">
        <Heading heading={typography.TAB_INBOX} />
        <Inbox />
      </Container>
    </div>
  );
}
